export class EnableNotesMode {
  static readonly type = '[PuzzleNotesMode] Enable';
  constructor() {}
}

export class DisableNotesMode {
  static readonly type = '[PuzzleNotesMode] Disable';
  constructor() {}
}
